'use client';
import {
  useActiveSubscription,
  useActiveTrial,
  useDateFormatPreference,
} from '@witmetrics/data-store';
import { API } from '@/api';
import { getAuthUrl } from '@/api/urls';
import { showErrorToaster } from '@/utils/toasters';
import { getSubscriptionUrl } from '@/utils/trials';
import { useToggle } from '@/hooks/useToggle';
import BackgroundBlobs from '@/components/BackgroundBlobs';
import Button from '@/components/Button';
import AccountsDialog from '@/dialogs/AccountsDialog';
import { LogoutIcon, SparklesIcon, SwapIcon } from '@/icons';
import { classes, getLockoutContent, getLockoutReason } from './utils';

export default function AccountLockout() {
  const activeSubscription = useActiveSubscription();
  const activeTrial = useActiveTrial();
  const dateFormat = useDateFormatPreference();
  const [isAccountsDialogOpen, toggleAccountsDialog] = useToggle();

  const handleContactSupport = () => {
    window.open(getSubscriptionUrl(), '_blank');
  };

  const handleSwitchAccount = () => toggleAccountsDialog(true);

  const handleCloseAccountsDialog = () => toggleAccountsDialog(false);

  const handleLogout = async () => {
    try {
      await API.Users.logout();
      // @ts-ignore
      window.location = `${getAuthUrl()}/login`;
    } catch (err) {
      showErrorToaster('Error logging out');
      throw err;
    }
  };

  const reason = getLockoutReason(activeTrial, activeSubscription);
  const { title, message, actionLabel } = getLockoutContent(
    reason,
    activeTrial,
    dateFormat
  );

  return (
    <div className={classes.wrapper}>
      <BackgroundBlobs />
      <div className={classes.card}>
        <span className={classes.iconTile}>
          <SparklesIcon size="1.5rem" />
        </span>
        <h1 className={classes.title}>{title}</h1>
        <p className={classes.message}>{message}</p>
        {actionLabel && (
          <Button
            className={classes.actionButton}
            onClick={handleContactSupport}>
            {actionLabel}
          </Button>
        )}
        <div className={classes.secondaryActions}>
          <Button
            className={classes.secondaryButton}
            variant="secondary"
            icon={<SwapIcon />}
            onClick={handleSwitchAccount}>
            Switch account
          </Button>
          <Button
            className={classes.secondaryButton}
            variant="ghost"
            icon={<LogoutIcon />}
            onClick={handleLogout}>
            Log out
          </Button>
        </div>
      </div>
      {isAccountsDialogOpen && (
        <AccountsDialog onClose={handleCloseAccountsDialog} />
      )}
    </div>
  );
}
